export const autoSaver = {
    leave: {
        label: "quitter", 
        title: "Navigation", 
        content: "Vos modifications seront perdues.<br>Souhaitez-vous vraiment quitter la page ?",
    }
}